import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";

export function useCancelShiftMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.cancel,
    onSuccess: () => invalidateShiftQueries(queryClient),
  });
}
